import React, { useEffect, useState } from "react";
import { Card, Button, Select, Form, Switch, Alert, message } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { useStore } from "../../store/store";
import { useJsqel } from "../../api/jsqel";
import userFeedback from "../widget/userFeedback";
import GoogleButtonImage from "./GoogleButtonImage";

const Settings = () => {
	const api_url = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000/";
	const { state } = useStore();
	const [oauthError, setOauthError] = useState(null);

	// Check for OAuth error in URL parameters
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const error = urlParams.get("error");
		const errorMessage = urlParams.get("message");

		if (error && errorMessage) {
			const decodedMessage = decodeURIComponent(errorMessage);
			setOauthError(decodedMessage);
			message.error(decodedMessage, 10);
			// Clean up URL without reloading the page
			window.history.replaceState({}, document.title, window.location.pathname);
		}
	}, []);

	const [lists, refresh] = useJsqel(
		`AuthenticationAndSettings/getCalendarList`,
		{
			sendItNow: false,
		}
	);

	const [lastSynchroStats] = useJsqel(`synchronization/lastSynchroStats`, {
		sendItNow: true,
	});

	const [, setCalendarChannel] = useJsqel(`googleCalendar/setCalendar`, {
		sendItNow: false,
		callback: (result) => {
			if (result && result.success === false) {
				userFeedback("Warning", () => { })("Calendar sync partially enabled. Google→Buzzee sync may not work immediately.");
			} else if (result && result.success === true) {
				userFeedback("Success", () => { })("Calendar sync fully enabled!");
			}
		}
	});
	const [userInfo, refreshInfo] = useJsqel("utilisateur/utilisateurById", {
		sendItNow: true,
	});

	const [, updateItem] = useJsqel(`utilisateur/updateUtilisateur`, {
		sendItNow: false,
		callback: userFeedback("Updating settings", refreshInfo),
	});

	const [, googleLogout] = useJsqel("auth/googleLogout", {
		sendItNow: false,
		callback: userFeedback("Logout Google done", refreshInfo),
	});

	const [, enableActiveSync] = useJsqel(`buzzee/enableActiveSync`, {
		sendItNow: false,
		callback: userFeedback("enableActiveSync done", refresh),
	});
	const [, disableActiveSync] = useJsqel(`buzzee/disableActiveSync`, {
		sendItNow: false,
		callback: userFeedback("disableActiveSync done", refresh),
	});

	const { Option } = Select;

	const handleChangeCalendar = async (value) => {
		await updateItem({ data: { calendar: value, id: state.id } });
		await setCalendarChannel({ calendar: value });
	};
	const handleChangeSynchronizationCalendar = (value) => {
		// Vérifier qu'un calendrier est sélectionné avant d'activer la sync
		if (value && (!userInfo.results[0] || !userInfo.results[0].calendar)) {
			userFeedback("Warning", () => { })("Please select a calendar first before enabling synchronization.");
			return;
		}
		updateItem({ data: { synchronizationcalendar: value, id: state.id } });
	};
	const handleChangeSynchronizationBuzzee = (value) => {
		value
			? enableActiveSync({ userId: state.id })
			: disableActiveSync({ userId: state.id });
		updateItem({ data: { synchronizationbuzzee: value, id: state.id } });
	};

	const handleDeleteGoogleAccount = () => googleLogout();

	return (
		<Card title="Settings">
			{userInfo.results[0] && userInfo.results[0].token ? (
				<>
					<p>
						<b>Your Google Account is signed in</b>
					</p>
					<Form.Item label="Choice of the agenda">
						<Select
							style={{ width: 250 }}
							defaultValue={userInfo.results[0].calendar}
							onChange={handleChangeCalendar}
							onClick={() => refresh()}
							placeholder="Choose a calendar to Synchronize"
						>
							{lists.results &&
								lists.results.length &&
								lists.results.map((item) => (
									<Option value={item.id}>{item.summary}</Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item label="Buzzee -> Google">
						{userInfo.results[0] &&
							userInfo.results[0].synchronizationcalendar === true ? (
							<Switch
								onChange={handleChangeSynchronizationCalendar}
								defaultChecked
							/>
						) : (
							<Switch onChange={handleChangeSynchronizationCalendar} />
						)}
						<span style={{ marginLeft: "1rem" }}>
							{lastSynchroStats.results.googleStats
								? `Last sync on ${new Date(
									lastSynchroStats.results.googleStats
								).toLocaleString()}`
								: "No sync"}
						</span>
					</Form.Item>
					<Form.Item label="Google -> Buzzee">
						{userInfo.results[0] &&
							userInfo.results[0].synchronizationbuzzee === true ? (
							<Switch
								onChange={handleChangeSynchronizationBuzzee}
								defaultChecked
							/>
						) : (
							<Switch onChange={handleChangeSynchronizationBuzzee} />
						)}
						<span style={{ marginLeft: "1rem" }}>
							{lastSynchroStats.results.buzzeeStats
								? `Last sync on ${new Date(
									lastSynchroStats.results.buzzeeStats
								).toLocaleString()}`
								: "No sync"}
						</span>
					</Form.Item>
					<Button
						type="primary"
						icon={<GoogleOutlined />}
						onClick={handleDeleteGoogleAccount}
					>
						Log out Google Account
					</Button>
				</>
			) : (
				<>
					{oauthError && (
						<Alert
							message="Erreur de connexion Google"
							description={
								<div>
									<p>{oauthError}</p>
									<img
										src="/google-calendar-permission.png"
										alt="Case à cocher pour autoriser l'accès à Google Agenda"
										style={{
											maxWidth: "100%",
											marginTop: 12,
											border: "1px solid #d9d9d9",
											borderRadius: 4
										}}
									/>
								</div>
							}
							type="error"
							showIcon
							closable
							onClose={() => setOauthError(null)}
							style={{ marginBottom: 16 }}
						/>
					)}
					<GoogleButtonImage
						href={`${api_url}AuthenticationAndSettings/login?userid=${state.id}&XMLC_UserName=${state.username}`}
					/>
				</>
			)}
		</Card>
	);
};

export default Settings;
